import commandEngine from './CommandEngine';
import tabEngine from '../../../TabEngine/TabEngine';

const TAB_IDS = ['yourdata', 'yournotes', 'search', 'library', 'settings'];

/**
 * Registers the /tab command with the CommandEngine.
 * Call once at module load from YourLibraryTab.
 *
 * /tab show <id>  — show a hidden tab
 * /tab hide <id>  — hide a tab
 * /tab hide all   — hide all tabs except the active one
 * /tab go <id>    — switch to a tab
 */
export function registerTabCommand() {
    commandEngine.register('/tab', {
        hint: 'Manage dashboard tabs',
        params: [
            { name: 'action', hints: ['show', 'hide', 'go'] },
            { name: 'tab', hints: [...TAB_IDS, 'all'] },
        ],
        handler: ([action, id]) => {
            if (action === 'hide' && id === 'all') {
                tabEngine.hideAllTabs();
                return;
            }
            if (action === 'show' && id === 'all') {
                tabEngine.showAllTabs();
                return;
            }
            if (action === 'hide') {
                tabEngine.hideTab(id);
                return;
            }
            if (action === 'show') {
                tabEngine.showTab(id);
                return;
            }
            if (action === 'go') {
                tabEngine.setTabById(id);
                return;
            }
        },
    });
}
